import { Http } from '@angular/http';
import { EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/http";
import * as i2 from "@angular/common/http";
import * as i3 from "../_services/utils.service";
var Manager = require("socket.io-client").Manager;
import { Howl } from 'howler';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from './../_services/utils.service';
var ResultboardService = /** @class */ (function () {
    function ResultboardService(_http, http, _utilsService) {
        var _this = this;
        this._http = _http;
        this.http = http;
        this._utilsService = _utilsService;
        this.draftPauseOrRestart = new EventEmitter();
        //callDraftSocket(user_id, league_id) -- I think call whenever switching to a draft
        this.newMsgReceive = new EventEmitter();
        this.activeDraftVisible = new EventEmitter();
        this.reconnectCount = 0;
        this.time1 = (new Date()).getTime();
        var currentUserDeatail = JSON.parse(localStorage.getItem('currentUser'));
        var jwt = currentUserDeatail && currentUserDeatail.token ? currentUserDeatail.token : "";
        if (!this.draftSocket) {
            var draftSocketManager = new Manager("" + environment.draftUrl, {
                transports: ['websocket'],
                query: { token: jwt }
            });
            this.draftSocket = draftSocketManager.socket("/");
        }
        if (!this.chatSocket) {
            var chatSocketManager = new Manager("" + environment.chatUrl, {
                transports: ['websocket'],
                query: { token: jwt }
            });
            this.chatSocket = chatSocketManager.socket("/");
        }
        this.draftSocket.on('error', function (reason) {
            // console.error(reason);
            // this.errorLog(reason).subscribe();
            // setTimeout(() => {
            //   location.reload();
            // }, 500);
            // try again forever
            setTimeout(function () {
                _this.reconnectCount++;
                if (_this.reconnectCount > 30) {
                    window.location.reload();
                }
                else {
                    // console.log('retrying socket connection');
                    _this.draftSocket.connect();
                }
            }, 1000);
        });
        this.draftSocket.on('connect', function () {
            var time2 = (new Date()).getTime();
            console.log('socket connected ', time2 - _this.time1);
            _this.reconnectCount = 0;
        });
        this.draftSocket.on('disconnect', function (res) {
            var time2 = (new Date()).getTime();
            console.log('socket disconnected', res, time2 - _this.time1);
            _this.draftSocket.connect();
        });
        this.draftSocket.on('conn_pong', function (res) {
            var time2 = (new Date()).getTime();
            console.log('conn_pong', time2 - _this.time1);
        });
        // setInterval(() => {
        //   this.ping2();
        // }, 20000);
    }
    ResultboardService.prototype.errorLog = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/user/angular-error-log', data);
    };
    ResultboardService.prototype.getRosterPosition = function (league_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/fantasyLeague/get-roster-position/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + league_id);
    };
    ResultboardService.prototype.getRankingSets = function (game_id, egs, lgs, user_id, league_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/league/get-ranked_games/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + game_id + '/' + egs + '/' + lgs + '/' + user_id + '/' + league_id);
    };
    ResultboardService.prototype.importRankings = function (league_id, league_member_id, common_rank_id, user_id) {
        return this._utilsService.postRequest(environment.phpApiUrl + "/league/import_rankings", {
            league_id: league_id,
            league_member_id: league_member_id,
            common_rank_id: common_rank_id,
            user_id: user_id
        });
    };
    ResultboardService.prototype.getScoring = function (league_id, game_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/fantasyLeague/get-scoring-groupwise/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + league_id + '/' + game_id);
    };
    ResultboardService.prototype.getQuotes = function () {
        var _this = this;
        this.draftSocket.on('data', function (res) {
            _this.observer.next(res.data);
        });
        return this.createObservable();
    };
    ResultboardService.prototype.enableManualAutoPick = function (league_id, lgm_id) {
        this.draftSocket.emit('enableMAutoPick', { league_id: league_id, lgm_id: lgm_id });
    };
    ResultboardService.prototype.disableAutoPick = function (league_id, lgm_id) {
        this.draftSocket.emit('disableMAutoPick', { league_id: league_id, lgm_id: lgm_id });
    };
    ResultboardService.prototype.ping = function () {
        this.draftSocket.emit('p_time', {});
    };
    ResultboardService.prototype.pong = function () {
        var localObserver;
        this.draftSocket.on('p_res', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (obj) {
            localObserver = obj;
        });
    };
    ResultboardService.prototype.ping2 = function () {
        this.draftSocket.emit('conn_ping', {});
    };
    ResultboardService.prototype.refreshPage = function () {
        var localObserver;
        this.draftSocket.on('refresh_page', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (obj) {
            localObserver = obj;
        });
    };
    ResultboardService.prototype.postManage = function (draftpost, league_id) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (this.currentUser != null) {
            this.postMessageData = { 'userID': this.currentUser.id, 'message': draftpost, 'display_name': this.currentUser.drafters_id, 'league_uuid': league_id };
            this.draftSocket.emit('post_draft_messages', this.postMessageData);
        }
        return this.createObservable();
    };
    ResultboardService.prototype.destroyDraftSocket = function (league_id) {
        var _this = this;
        this.draftSocket.emit('draft_destroy', league_id);
        return new Observable(function (destroyDraftObserver) {
            _this.destroyDraftObserver = destroyDraftObserver;
        });
    };
    ResultboardService.prototype.callDraftSocket = function (user_id, league_id) {
        var userRoom = { 'user_id': user_id, 'league_id': league_id };
        this.draftSocket.emit('resultboard_init', userRoom);
        return this.createDraftObservable();
    };
    ResultboardService.prototype.callDraftApp = function (user_id, league_id) {
        var userRoom = { user_id: user_id, league_id: league_id, is_app: '1' };
        this.draftSocket.emit('app_init', userRoom);
    };
    ResultboardService.prototype.draftAppListener = function () {
        var localObserver;
        this.draftSocket.on('init_draft_data', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (obj) {
            localObserver = obj;
        });
    };
    ResultboardService.prototype.emitAutoDraft = function (user_id, league_id) {
        var _this = this;
        var userRoom = { 'user_id': user_id, 'league_id': league_id };
        this.draftSocket.emit('enable_autopick_mode', userRoom);
        return new Observable(function (emitAutoDraftObserver) {
            _this.emitAutoDraftObserver = emitAutoDraftObserver;
        });
    };
    // disconnect(): Observable<any> {
    //   let localObserver;
    //   this.draftSocket.on('disconnect', (res) => {
    //     // window.location.reload();
    //     localObserver.next(res);
    //   });
    //   return new Observable<any>(disconnectObserver => {
    //     localObserver = disconnectObserver;
    //   });
    // }
    ResultboardService.prototype.predraft = function () {
        var _this = this;
        this.draftSocket.on('predraft', function (res) {
            _this.draftObserver.next(res);
        });
        return this.createAnyObservable();
    };
    ResultboardService.prototype.readybox = function () {
        var localObserver;
        this.draftSocket.on('ready_box', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (obs) {
            localObserver = obs;
        });
    };
    ResultboardService.prototype.disconnectEvent = function () {
        var localObserver;
        this.draftSocket.on('disconnect', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (obs) {
            localObserver = obs;
        });
    };
    ResultboardService.prototype.connectEvent = function () {
        var localObserver;
        this.draftSocket.on('connect', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (obs) {
            localObserver = obs;
        });
    };
    ResultboardService.prototype.listActiveDraft = function () {
        var localObserver;
        this.draftSocket.on('list_active_draft', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (obs) {
            localObserver = obs;
        });
    };
    ResultboardService.prototype.total_ready_member = function () {
        var _this = this;
        this.draftSocket.on('total_ready_member', function (res) {
            _this.readyMemberObserver.next(res);
        });
        return new Observable(function (readyMemberObserver) {
            _this.readyMemberObserver = readyMemberObserver;
        });
    };
    ResultboardService.prototype.pickerTime = function () {
        var _this = this;
        this.draftSocket.on('pick_timer', function (res) {
            _this.pickerTimeObserver.next(res);
        });
        return this.createPickerTimeObservable();
    };
    ResultboardService.prototype.pickTime = function () {
        var _this = this;
        this.draftSocket.on('pick_timer', function (res) {
            _this.pickTimeO.next(res);
        });
        return new Observable(function (obs) {
            _this.pickTimeO = obs;
        });
    };
    ResultboardService.prototype.init_data = function () {
        var _this = this;
        this.draftSocket.on('init_data', function (res) {
            _this.initDataObserver.next(res);
        });
        return this.createinitDataObservable();
    };
    ResultboardService.prototype.picked_player = function () {
        var _this = this;
        this.draftSocket.on('picked_player', function (res) {
            _this.pickedPlayerObserver.next(res);
        });
        return new Observable(function (pickedPlayerObserver) {
            _this.pickedPlayerObserver = pickedPlayerObserver;
        });
    };
    ResultboardService.prototype.pickedPlayer = function () {
        var localObservable;
        this.draftSocket.on('picked_player', function (res) {
            localObservable.next(res);
        });
        return new Observable(function (obs) {
            localObservable = obs;
        });
    };
    ResultboardService.prototype.draft_complete = function () {
        var _this = this;
        this.draftSocket.on('draft_complete', function (res) {
            _this.draftCompleteObserver.next(res);
        });
        return new Observable(function (draftCompleteObserver) {
            _this.draftCompleteObserver = draftCompleteObserver;
        });
    };
    ResultboardService.prototype.draftCompleted = function () {
        var _this = this;
        this.draftSocket.on('draft_complete', function (res) {
            _this.draftCompletedO.next(res);
        });
        return new Observable(function (obs) {
            _this.draftCompletedO = obs;
        });
    };
    ResultboardService.prototype.iAmReadyForJoinLeague = function (data) {
        this.draftSocket.emit('i_am_ready', data);
        return this.createObservable();
        // data => {user_id, league_id, entrants}
    };
    ResultboardService.prototype.imReady = function (league_id, user_id, entrants) {
        this.draftSocket.emit('i_am_ready', {
            league_id: league_id,
            user_id: user_id,
            entrants: entrants
        });
    };
    ResultboardService.prototype.leaveRoom = function (league_id) {
        this.draftSocket.emit('destroy_lg_socket', {
            league_id: league_id
        });
    };
    ResultboardService.prototype.autodraftfalseEmit = function (user_id, league_id) {
        var _this = this;
        var userData = { 'user_id': user_id, 'league_id': league_id };
        this.draftSocket.emit('ang_autodraftfalse', userData);
        return new Observable(function (autodraftfalseEmitObserver) {
            _this.autodraftfalseEmitObserver = autodraftfalseEmitObserver;
        });
    };
    ResultboardService.prototype.activeDraftEmit = function (data) {
        var _this = this;
        this.draftSocket.emit('active_draft', data);
        return new Observable(function (activeDraftObserver) {
            _this.activeDraftObserver = activeDraftObserver;
        });
    };
    ResultboardService.prototype.emitActiveDraft = function (data) {
        this.draftSocket.emit('active_draft', data);
    };
    ResultboardService.prototype.showActiveDraftData = function () {
        var _this = this;
        this.draftSocket.on('show_draft_Status', function (res) {
            _this.activeDraftDataObserver.next(res);
        });
        return new Observable(function (activeDraftDataObserver) {
            _this.activeDraftDataObserver = activeDraftDataObserver;
        });
    };
    ResultboardService.prototype.showDraftStatus = function () {
        var localObserver;
        this.draftSocket.on('show_draft_status', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (obs) {
            localObserver = obs;
        });
    };
    ResultboardService.prototype.activeDraftPickChanges = function () {
        var _this = this;
        this.draftSocket.on('pick_changes', function (res) {
            _this.activeDraftPickObserver.next(res);
        });
        return new Observable(function (activeDraftPickObserver) {
            _this.activeDraftPickObserver = activeDraftPickObserver;
        });
    };
    ResultboardService.prototype.pickChanges = function () {
        var localObservable;
        this.draftSocket.on('pick_changes', function (res) {
            localObservable.next(res);
        });
        return new Observable(function (obs) {
            localObservable = obs;
        });
    };
    ResultboardService.prototype.lastPickReverse = function () {
        var localObservable;
        this.draftSocket.on('Draft last pick reverse msg', function (res) {
            localObservable.next(res);
        });
        return new Observable(function (obs) {
            localObservable = obs;
        });
    };
    ResultboardService.prototype.draftResetCounter = function () {
        var _this = this;
        this.draftSocket.on('draft_restart_counter', function (res) {
            _this.draftResetCounterObserver.next(res);
        });
        return new Observable(function (draftResetCounterObserver) {
            _this.draftResetCounterObserver = draftResetCounterObserver;
        });
    };
    ResultboardService.prototype.draftReset = function () {
        var localObserver;
        this.draftSocket.on('draft_restart_counter', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (obs) {
            localObserver = obs;
        });
    };
    ResultboardService.prototype.restart_msg = function () {
        var _this = this;
        this.draftSocket.on('restart_msg', function (res) {
            _this.restart_msgObserver.next(res);
        });
        return new Observable(function (restart_msgObserver) {
            _this.restart_msgObserver = restart_msgObserver;
        });
    };
    ResultboardService.prototype.updateLeagueMember = function () {
        var _this = this;
        this.draftSocket.on('update_league_member', function (res) {
            _this.updateLeagueMemberObserver.next(res);
        });
        return new Observable(function (updateLeagueMemberObserver) {
            _this.updateLeagueMemberObserver = updateLeagueMemberObserver;
        });
    };
    ResultboardService.prototype.updateTournamentMember = function () {
        var _this = this;
        this.draftSocket.on('update_tournament_member', function (res) {
            _this.updateTournamentMemberObserver.next(res);
        });
        return new Observable(function (updateTournamentMemberObserver) {
            _this.updateTournamentMemberObserver = updateTournamentMemberObserver;
        });
    };
    ResultboardService.prototype.draftButtonEmit = function (data) {
        var _this = this;
        this.draftSocket.emit('pick player', data);
        return new Observable(function (draftButtonObserver) {
            _this.draftButtonObserver = draftButtonObserver;
        });
    };
    ResultboardService.prototype.saveDraftRankEmit = function (data) {
        var _this = this;
        this.draftSocket.emit('save_draft_rank', data);
        return new Observable(function (saveDraftRankObserver) {
            _this.saveDraftRankObserver = saveDraftRankObserver;
        });
    };
    ResultboardService.prototype.messageLeaguePost = function () {
        var _this = this;
        this.draftSocket.on('league post', function (res) {
            _this.messageObserver.next(res);
        });
        return new Observable(function (messageObserver) {
            _this.messageObserver = messageObserver;
        });
    };
    ResultboardService.prototype.leaguePost = function () {
        var localObservable;
        this.draftSocket.on('league post', function (res) {
            localObservable.next(res);
        });
        return new Observable(function (obs) {
            localObservable = obs;
        });
    };
    ResultboardService.prototype.draftMessage = function () {
        var localObserver;
        this.draftSocket.on('display draft messages', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (draftMessageObserver) {
            localObserver = draftMessageObserver;
        });
    };
    ResultboardService.prototype.draftPausedMessage = function () {
        var _this = this;
        this.draftSocket.on('Draft paused message', function (res) {
            _this.draftPauseOrRestart.emit(true);
            _this.draftPausedMessageObserver.next(res);
        });
        return new Observable(function (draftPausedMessageObserver) {
            _this.draftPausedMessageObserver = draftPausedMessageObserver;
        });
    };
    ResultboardService.prototype.pausedMessage = function () {
        var localObserver;
        this.draftSocket.on('Draft paused message', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (obs) {
            localObserver = obs;
        });
    };
    ResultboardService.prototype.draftResumeMessage = function () {
        var _this = this;
        this.draftSocket.on('Draft resume message', function (res) {
            _this.draftPauseOrRestart.emit(true);
            _this.draftResumeMessageObserver.next(res);
        });
        return new Observable(function (draftResumeMessageObserver) {
            _this.draftResumeMessageObserver = draftResumeMessageObserver;
        });
    };
    ResultboardService.prototype.resumeMessage = function () {
        var localObserver;
        this.draftSocket.on('Draft resume message', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (obs) {
            localObserver = obs;
        });
    };
    ResultboardService.prototype.activePickChanges = function () {
        var _this = this;
        this.draftSocket.on('active_pick_changes', function (res) {
            _this.activePickChangesObserver.next(res);
        });
        return new Observable(function (activePickChangesObserver) {
            _this.activePickChangesObserver = activePickChangesObserver;
        });
    };
    ResultboardService.prototype.getNewActiveLeague = function () {
        var localObserver;
        this.draftSocket.on('active_pick_changes', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (response) {
            localObserver = response;
        });
    };
    ResultboardService.prototype.updatePaymentSatus = function () {
        var localObserver;
        this.draftSocket.on('deposit_status', function (res) {
            localObserver.next(res);
        });
        return new Observable(function (obs) {
            localObserver = obs;
        });
    };
    ResultboardService.prototype.draftActiveEmit = function (league_id, player_id) {
        var _this = this;
        var data = { 'league_id': league_id, 'player_id': player_id };
        this.draftSocket.emit('draft_active', data);
        return new Observable(function (draftActiveReqObserver) {
            _this.draftActiveReqObserver = draftActiveReqObserver;
        });
    };
    ResultboardService.prototype.sendDraftActive = function (league_id, player_id, position) {
        this.draftSocket.emit('draft_active_app', {
            league_id: league_id,
            player_id: player_id,
            position: position
        });
    };
    ResultboardService.prototype.draftActiveOn = function () {
        var observer;
        this.draftSocket.on('draft_active', function (res) {
            observer.next(res);
        });
        return new Observable(function (draftActiveOnObserver) {
            observer = draftActiveOnObserver;
        });
    };
    /* header chat emit and listen socket */
    ResultboardService.prototype.getMessagesEmit = function (userID, chat_cursor, type) {
        var _this = this;
        if (type === void 0) { type = ''; }
        var data = { 'userID': userID, 'chat_cursor': chat_cursor, 'dropdown': type, 'is_app': 'No' };
        this.chatSocket.emit('get messages', data);
        return new Observable(function (getMessagesObserver) {
            _this.getMessagesObserver = getMessagesObserver;
        });
    };
    ResultboardService.prototype.displayMessages = function () {
        var _this = this;
        this.chatSocket.on('disply messages', function (res) {
            _this.displayMessagesObserver.next(res);
        });
        return new Observable(function (displayMessagesObserver) {
            _this.displayMessagesObserver = displayMessagesObserver;
        });
    };
    ResultboardService.prototype.showMessages = function () {
        var _this = this;
        this.chatSocket.on('disply messages', function (res) {
            _this.showMessagesObserver.next(res);
        });
        return new Observable(function (showMessagesObserver) {
            _this.showMessagesObserver = showMessagesObserver;
        });
    };
    ResultboardService.prototype.receiveMessage = function () {
        var _this = this;
        this.chatSocket.on('receive message', function (res) {
            _this.receiveMessageObserver.next(res);
        });
        return new Observable(function (receiveMessageObserver) {
            _this.receiveMessageObserver = receiveMessageObserver;
        });
    };
    ResultboardService.prototype.newMessage = function () {
        var _this = this;
        return new Observable(function (observer) {
            _this.draftSocket.on('new message', function (res) {
                observer.next(res);
            });
        });
    };
    ResultboardService.prototype.friendInviteNoti = function () {
        var _this = this;
        this.chatSocket.on('friend invite notification', function (res) {
            _this.friendInviteNotiObserver.next(res);
        });
        return new Observable(function (friendInviteNotiObserver) {
            _this.friendInviteNotiObserver = friendInviteNotiObserver;
        });
    };
    ResultboardService.prototype.friendMsgInviteNoti = function () {
        var _this = this;
        this.chatSocket.on('friend msg notification', function (res) {
            _this.friendMsgInviteNotiObserver.next(res);
        });
        return new Observable(function (friendMsgInviteNotiObserver) {
            _this.friendMsgInviteNotiObserver = friendMsgInviteNotiObserver;
        });
    };
    ResultboardService.prototype.updateReqCount = function (userID, counter) {
        var _this = this;
        var data = { 'userID': userID, 'counter': counter };
        this.chatSocket.emit('update_req_count', data);
        return new Observable(function (updateReqCountObserver) {
            _this.updateReqCountObserver = updateReqCountObserver;
        });
    };
    ResultboardService.prototype.addActiveUser = function (data) {
        var _this = this;
        this.chatSocket.emit('add_active_user', data);
        return new Observable(function (addActiveUserObserver) {
            _this.addActiveUserObserver = addActiveUserObserver;
        });
    };
    ResultboardService.prototype.getNotification = function (user_id, noti_cursor) {
        var _this = this;
        var data = { 'userID': user_id, 'noti_cursor': noti_cursor, 'is_app': 'no' };
        this.chatSocket.emit('get notification', data);
        return new Observable(function (getNotificationObserver) {
            _this.getNotificationObserver = getNotificationObserver;
        });
    };
    ResultboardService.prototype.displyNotifications = function () {
        var _this = this;
        this.chatSocket.on('disply notifications', function (res) {
            _this.displyNotificationsObserver.next(res);
        });
        return new Observable(function (displyNotificationsObserver) {
            _this.displyNotificationsObserver = displyNotificationsObserver;
        });
    };
    ResultboardService.prototype.userTyping = function (data) {
        this.chatSocket.emit("userTyping", data);
    };
    ResultboardService.prototype.getContacts = function (data) {
        this.chatSocket.emit("get contacts", data);
    };
    ResultboardService.prototype.getIndidualChat = function (data) {
        this.chatSocket.emit("get_indidual_chat", data);
    };
    ResultboardService.prototype.post_message = function (data) {
        this.chatSocket.emit("post_messages", data);
    };
    ResultboardService.prototype.send_message = function (data) {
        this.chatSocket.emit("send message", data);
    };
    ResultboardService.prototype.readMsgCount = function (data) {
        this.chatSocket.emit("read_msg_count", data);
    };
    ResultboardService.prototype.updateMessageReceived = function (data) {
        this.chatSocket.emit("update message received", data);
    };
    ResultboardService.prototype.displyContacts = function () {
        var _this = this;
        this.chatSocket.on('disply contacts', function (res) {
            _this.displyContactsObserver.next(res);
        });
        return new Observable(function (displyContactsObserver) {
            _this.displyContactsObserver = displyContactsObserver;
        });
    };
    ResultboardService.prototype.priorChat = function () {
        var _this = this;
        this.chatSocket.on('prior_chat', function (res) {
            _this.priorChatObserver.next(res);
        });
        return new Observable(function (priorChatObserver) {
            _this.priorChatObserver = priorChatObserver;
        });
    };
    ResultboardService.prototype.receiveUserTyping = function () {
        var _this = this;
        this.draftSocket.on('receiveUserTyping', function (res) {
            _this.receiveUserTypingObserver.next(res);
        });
        return new Observable(function (receiveUserTypingObserver) {
            _this.receiveUserTypingObserver = receiveUserTypingObserver;
        });
    };
    ResultboardService.prototype.deactiveUser = function () {
        var _this = this;
        this.draftSocket.on('deactive_user', function (res) {
            _this.deactiveUserObserver.next(res);
        });
        return new Observable(function (deactiveUserObserver) {
            _this.deactiveUserObserver = deactiveUserObserver;
        });
    };
    ResultboardService.prototype.receiveActiveUser = function () {
        var _this = this;
        this.draftSocket.on('receive_active_user', function (res) {
            _this.receiveActiveUserObserver.next(res);
        });
        return new Observable(function (receiveActiveUserObserver) {
            _this.receiveActiveUserObserver = receiveActiveUserObserver;
        });
    };
    ResultboardService.prototype.receiveNewChatUser = function () {
        var _this = this;
        this.draftSocket.on('receive_new_chat_user', function (res) {
            _this.receiveNewChatUserObserver.next(res);
        });
        return new Observable(function (receiveNewChatUserObserver) {
            _this.receiveNewChatUserObserver = receiveNewChatUserObserver;
        });
    };
    ResultboardService.prototype.playSound = function () {
        var sound = new Howl({
            src: ["/" + environment.ANGULAR_FOLDER_NMAE + '/assets/media/cool-notifications.mp3'],
            autoplay: true,
            loop: false,
            volume: 1.0,
            onend: function () {
            }
        });
    };
    ResultboardService.prototype.getByeWeeks = function (game_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/teams/byeWeeks/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + game_id);
    };
    ResultboardService.prototype.getInfoTabs = function (tour_id, league_id, user_id, tab) {
        var url;
        if (tour_id > 0) {
            url = "" + environment.phpApiUrl + '/tournament/infoBox/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + tour_id + '/' + league_id + '/' + user_id + '/' + tab;
        }
        else {
            url = "" + environment.phpApiUrl + '/fantasyLeague/infoBox/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + league_id + '/' + user_id + '/' + tab;
        }
        return this._utilsService.getRequest(url);
    };
    ResultboardService.prototype.getInfobox = function (player_id, season_id, league_id, abbr, tab, simple, cache) {
        if (simple === void 0) { simple = 'N'; }
        if (cache === void 0) { cache = false; }
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/player/player-info-app-expand/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + player_id + '/' + season_id + '/' + league_id + '/' + abbr + '/' + tab + '?simple=' + simple + '&cache=' + cache);
    };
    ResultboardService.prototype.getDraftChat = function (league_id, filter_type, page) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/user_posts/get-draft-league-post/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + league_id + '/' + filter_type + '/' + page);
    };
    ResultboardService.prototype.getActiveSeason = function (game_id) {
        return this._utilsService.getRequest(environment.boxScoreUrl + "/activeSeason/" + game_id);
    };
    ResultboardService.prototype.createObservable = function () {
        var _this = this;
        return new Observable(function (observer) {
            _this.observer = observer;
        });
    };
    ResultboardService.prototype.createAnyObservable = function () {
        var _this = this;
        return new Observable(function (draftObserver) {
            _this.draftObserver = draftObserver;
        });
    };
    ResultboardService.prototype.createDraftObservable = function () {
        var _this = this;
        return new Observable(function (observer) {
            _this.observer = observer;
        });
    };
    ResultboardService.prototype.createPickerTimeObservable = function () {
        var _this = this;
        return new Observable(function (pickerTimeObserver) {
            _this.pickerTimeObserver = pickerTimeObserver;
        });
    };
    ResultboardService.prototype.createinitDataObservable = function () {
        var _this = this;
        return new Observable(function (initDataObserver) {
            _this.initDataObserver = initDataObserver;
        });
    };
    ResultboardService.prototype.manageCounter = function () {
        this.socket.emit('clientdata', {
            msg: 'Yes, its working for me!!'
        });
    };
    ResultboardService.prototype.messageReceiveEmit = function (data) {
        this.newMsgReceive.emit(data);
    };
    ResultboardService.prototype.activeDraftVisibleEmit = function (isVisible) {
        this.activeDraftVisible.emit(isVisible);
    };
    ResultboardService.prototype.handleError = function (error) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            var errMessage = error.error.message;
            return Observable.throw(errMessage);
        }
        return Observable.throw(error || 'Socket.io server error');
    };
    ResultboardService.prototype.userChatTyping = function (data) {
        this.chatSocket.emit("userChatTyping", data);
    };
    ResultboardService.prototype.getOnlineContact = function (data) {
        this.chatSocket.emit("getOnlineContact", data);
    };
    ResultboardService.prototype.receiveUserChatTyping = function () {
        var _this = this;
        return new Observable(function (observer) {
            _this.draftSocket.on('receive user chat typing', function (res) {
                observer.next(res);
            });
        });
    };
    ResultboardService.prototype.receiveOnlineContact = function () {
        var _this = this;
        return new Observable(function (observer) {
            _this.draftSocket.on('receive online contact', function (res) {
                observer.next(res);
            });
        });
    };
    ResultboardService.ngInjectableDef = i0.defineInjectable({ factory: function ResultboardService_Factory() { return new ResultboardService(i0.inject(i1.Http), i0.inject(i2.HttpClient), i0.inject(i3.UtilsService)); }, token: ResultboardService, providedIn: "root" });
    return ResultboardService;
}());
export { ResultboardService };
